<div class="container text-center text-white py-3">
    <div class="welcome-to">Our</div>
    <h2>services</h2>
</div>

<div class="container p-3 text-white text-center">

    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5">

        <h3 class="py-3">DOCKS</h3>

        <p>The first set of beautiful NY-DOCK floating docks were installed in 2014. The last dock was dropped onto the ice in 2015.  These docks are very stable, and are at a height that makes boarding your boat very easy.</p>

    </div>
    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5 mt-2">

        <h3 class="py-3">GAS</h3>

        <p>We sell premium grade ethanol free gasoline, available to members.</p>

        <p>Nearly all road gas station fuel grades contain Ethanol, which absorbs moisture from the atmosphere and passes it through the boat's engine.  Forcing moisture laden fuel through your boat engine can cause a wide variety of problems, from rough starting to premature component failure. While some boats/motors can handle ethanol fuels, many cannot.   In addition, many PWC's recommend only using 91 octane (premium) grade fuel.</p>

    </div>
    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5 mt-2">

        <h3 class="py-3">COTTAGE RENTAL</h3>

        <p>Seasonal cottage rental available with beautiful lakeside views.  Contact us for more information.</p>

    </div>
    <div class="card bg-body-tertiary bg-opacity-75 p-3 px-5 mt-2">

        <h3 class="py-3">TRAILER STORAGE</h3>

        <p>No room at the cottage, or tired of looking at your boat trailer all summer?</p>
        <p>Members enjoy access to trailer storage.</p>

    </div>

</div>